/*
  Live filteren op de klantenservicepagina (progressive enhancement).

  Zonder JavaScript is het zoekveld een gewoon formulier dat naar
  /search stuurt -- dat blijft werken. Met JavaScript filtert het
  tijdens typen de fase-kaarten, de service/advies-panelen en de
  veelgestelde vragen die op deze pagina staan. Enter blijft de
  ontsnappingsroute naar de sitewide zoekfunctie, want die inhoud
  (productpagina's, blogs) staat hier niet.

  Reden voor het filteren: Shopify's storefront-zoekfunctie indexeert
  alleen paginatitel en body_html, en de servicepagina's hebben vrijwel
  lege bodies -- alle FAQ-inhoud staat in section settings. Zoeken op
  "bedenktijd" of "levertijd" levert daar dus niets op, terwijl het
  antwoord wel op deze pagina staat.
*/
(() => {
  const wortel = document.querySelector('[data-solza-service]');
  if (!wortel) return;

  const veld = wortel.querySelector('[data-service-zoekveld]');
  const melding = wortel.querySelector('[data-service-melding]');
  if (!veld) return;

  const groepen = [...wortel.querySelectorAll('[data-service-filterbaar]')];
  if (!groepen.length) return;

  // Elk filterbaar item onthoudt zijn eigen zoektekst, zodat we niet bij
  // elke toetsaanslag de DOM opnieuw hoeven uit te lezen.
  const items = groepen.map((el) => ({
    el,
    tekst: (el.textContent || '').toLowerCase().replace(/\s+/g, ' '),
    container: el.closest('[data-service-groep]')
  }));

  const containers = [...new Set(items.map((i) => i.container).filter(Boolean))];
  const meldingSjabloon = melding ? melding.dataset.sjabloon || '' : '';

  const normaliseer = (waarde) =>
    (waarde || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();

  function filter() {
    const term = normaliseer(veld.value);

    if (term.length < 2) {
      items.forEach((i) => i.el.removeAttribute('hidden'));
      containers.forEach((c) => c.removeAttribute('hidden'));
      if (melding) melding.setAttribute('hidden', '');
      wortel.removeAttribute('data-filtert');
      return;
    }

    wortel.setAttribute('data-filtert', '');
    const woorden = term.split(/\s+/).filter(Boolean);
    let treffers = 0;

    items.forEach((i) => {
      const tekst = normaliseer(i.tekst);
      const raak = woorden.every((w) => tekst.includes(w));
      if (raak) {
        i.el.removeAttribute('hidden');
        treffers += 1;
      } else {
        i.el.setAttribute('hidden', '');
      }
    });

    // Een groep zonder zichtbare items verdwijnt in zijn geheel, inclusief
    // de kop -- anders blijven er lege kaders staan.
    containers.forEach((c) => {
      const zichtbaar = items.some((i) => i.container === c && !i.el.hasAttribute('hidden'));
      if (zichtbaar) {
        c.removeAttribute('hidden');
      } else {
        c.setAttribute('hidden', '');
      }
    });

    if (melding) {
      if (treffers === 0) {
        melding.querySelector('[data-service-meldingtekst]').textContent = meldingSjabloon.replace(
          '%term%',
          veld.value.trim()
        );
        const link = melding.querySelector('[data-service-alleslink]');
        if (link) {
          link.href = link.dataset.basis + encodeURIComponent(veld.value.trim());
        }
        melding.removeAttribute('hidden');
      } else {
        melding.setAttribute('hidden', '');
      }
    }
  }

  let wacht;
  veld.addEventListener('input', () => {
    clearTimeout(wacht);
    wacht = setTimeout(filter, 120);
  });

  // Escape wist het filter -- sneller dan het veld handmatig leegmaken.
  veld.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && veld.value) {
      e.preventDefault();
      veld.value = '';
      filter();
    }
  });
})();
